import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=c4b22886&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=tsx&"
export * from "./edit.vue?vue&type=script&lang=tsx&"
import style0 from "./edit.vue?vue&type=style&index=0&id=c4b22886&prod&lang=scss&scoped=true&"
import style1 from "./edit.vue?vue&type=style&index=1&id=c4b22886&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b22886",
  null
  
)

export default component.exports